var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicwand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6454_2913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8901 40.9986C38.6005 40.9903 38.4571 40.7586 38.2847 40.5848C32.7575 34.9989 27.2317 29.4108 21.7073 23.8203C19.1548 21.2394 16.6173 18.6433 14.0468 16.0802C13.6441 15.6788 13.6676 15.4581 14.0689 15.1215C14.4384 14.8105 14.7799 14.4675 15.0894 14.0966C15.4024 13.7186 15.6024 13.7669 15.9389 14.0966C19.0371 17.17 22.1477 20.2328 25.2708 23.2851C30.3364 28.2594 35.4025 33.2337 40.4691 38.208C41.1751 38.8977 41.1724 38.9336 40.4842 39.6288C40.1165 40.004 39.7423 40.3769 39.3617 40.7476C39.2307 40.8827 39.0997 41.0152 38.8901 40.9986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4978 12.7434C14.4895 12.7999 14.4978 12.8289 14.4812 12.8413C13.9048 13.4303 13.3352 14.0276 12.7381 14.5946C12.6223 14.7049 12.5064 14.5008 12.4182 14.4125C11.0759 13.0588 9.73551 11.7042 8.39693 10.3486C8.10044 10.0493 8.07975 9.75685 8.39003 9.45613C8.40658 9.44095 8.42313 9.4244 8.4383 9.40784C9.98971 7.83803 9.67943 7.98288 11.0461 9.31956C12.0812 10.3312 13.1128 11.3428 14.1406 12.3544C14.2702 12.4951 14.3888 12.633 14.4978 12.7434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3979 8.62156C20.018 8.54707 21.3736 7.22969 21.5419 4.54528C21.7142 7.24901 23.1043 8.56224 25.7796 8.67536C23.1595 8.85606 21.6632 10.0879 21.6246 12.804C21.1819 11.7543 21.2385 10.5514 20.4193 9.76926C19.6002 8.98711 18.439 9.01884 17.3979 8.62156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38314 4.12179C7.24268 4.49563 6.03878 4.44321 5.23343 5.2626C4.42807 6.082 4.46807 7.23108 4.13986 8.34567C3.95369 7.62008 3.78407 7.00071 3.63651 6.37444C3.41173 5.42952 2.80909 4.87084 1.8879 4.63771C1.25013 4.48584 0.62048 4.30167 0.00138092 4.08593C2.64361 3.99075 4.00057 2.64717 4.06953 -0.00413513C4.48324 1.05666 4.43911 2.27195 5.26239 3.05686C6.08567 3.84177 7.2151 3.85694 8.38314 4.12179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38078 20.3276C8.62998 20.1717 9.78837 19.0447 9.83802 16.8169C10.2255 17.6914 10.1745 18.6943 10.8351 19.3633C11.4956 20.0324 12.4802 20.0379 13.3752 20.3689C11.1357 20.4669 10.0531 21.6698 9.90283 23.8934C9.7801 21.6311 8.65067 20.4862 6.38078 20.3276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68989 14.3366C4.07642 14.4884 3.25176 15.3257 3.12903 16.941C2.97871 15.3436 2.17749 14.458 0.528172 14.349C2.1706 14.2111 3.01043 13.3765 3.11386 11.7433C3.27245 13.3365 4.02953 14.247 5.68989 14.3366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0478 3.19204C14.8591 3.31757 14.2206 3.90384 14.1172 5.13293C13.9792 3.96316 13.4276 3.2886 12.1948 3.2017C13.3587 3.03341 14.0344 2.48852 14.0951 1.25254C14.2551 2.44714 14.8342 3.07755 16.0478 3.19204Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6454_2913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicwand);
export default __webpack_public_path__ + "static/media/magicwand.efa6e70df9653df406373ef79e166176.svg";
export { ForwardRef as ReactComponent };